import type React from 'react';

export type TextInputProps = React.InputHTMLAttributes<HTMLInputElement>;

export function TextInput({ value, ...props }: TextInputProps): JSX.Element {
  return (
    <input
      type={props.type ?? 'text'}
      className={[
        'block w-full rounded-md border border-slate-300 px-3 py-2 text-sm',
        'shadow-sm focus:border-slate-500 focus:ring-1 focus:ring-slate-500',
        'disabled:cursor-not-allowed disabled:bg-slate-50 disabled:text-slate-400',
        props.className,
      ]
        .filter(Boolean)
        .join(' ')}
      value={value ?? ''}
      {...props}
    />
  );
}
